module.exports = __webpack_public_path__ + "img/logo.22057e6e.png";